import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/map';
import { HttpUtils } from '../http/http-utils';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class VcaAlarmsService {

    private alarmDetailApI: string = '/hybridity/api/alarms/query?jobId=';
    private response: any;
    // stores all org from data store
    private _alarm$: Subject<any>;
    // stores all org fetched from DB
    private dataStore: {
        alarm: any[]
    };
    // stores selected org from detail view
    private currentAlarm: any = null;

    constructor(public http: HttpClient) {
        this.dataStore = { alarm: [] };
        this._alarm$ = <Subject<any[]>>new Subject();
    }

    getCurrentAlarm(jobId) {
        return this.currentAlarm;
    }

    setCurrentAlarm(alarm) {
        this.currentAlarm = alarm;
    }

    // returns observer, it notifies if array is changed
    get alarm() {
        return this._alarm$.asObservable();
    }

    /*
     * load alarm/job details
     */

    getAlarm(jobId: string) {
        return this.http
            .get(HttpUtils.getBaseUrl() + this.alarmDetailApI + jobId)
    }

    acknowledgeAlarm(payload: any) {
        let restUrl = HttpUtils.getBaseUrl() + "/hybridity/api/techsupport/alerts?action=acknowledge";
        return this.http
            .post(restUrl, JSON.stringify(payload))
    }

}



// WEBPACK FOOTER //
// ./src/common/vca-alarms/vca-alarms.service.ts